import React from "react";
import images from "../../assets";
import PrimaryButton from "../button/primarybutton";
import CustomizeColumnBox from "./customizecolumnsbox";

export default function CustomizeColumn(props) {
  return (
    <div className="flex flex-col">
      <div className="h-14 px-6 py-3 bg-white rounded-tl-2xl rounded-tr-2xl justify-between items-center inline-flex">
        <div className="text-[#222222] text-2xl font-semibold  leading-loose">
          Customize Columns
        </div>
        <div className="w-8 h-8 justify-center items-center flex">
          <div className="w-8 h-8 justify-center items-center inline-flex">
            <div className="w-8 h-8 relative">
              <img
                className="cursor-pointer"
                {...props}
                src={images.crossSquire}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full p-6 bg-white flex-col justify-start items-center gap-2 inline-flex">
        <CustomizeColumnBox titlename="Photo" />
        <CustomizeColumnBox titlename="User ID" />
        <CustomizeColumnBox titlename="Name" />
        <CustomizeColumnBox titlename="Gender" />
        <CustomizeColumnBox titlename="Country" />
        <CustomizeColumnBox titlename="City / State" />
        <CustomizeColumnBox titlename="Age" />
        <CustomizeColumnBox titlename="Marital Status" />
        <CustomizeColumnBox titlename="Email" />
        <CustomizeColumnBox titlename="Phone No." />
        <CustomizeColumnBox titlename="Profile Completeness" />
        <CustomizeColumnBox titlename="Registered Date" />
        <CustomizeColumnBox titlename="Registration Source" />
        <CustomizeColumnBox titlename="Membership Status" />
        <CustomizeColumnBox titlename="Account Status" />
      </div>
      <div className="h-24 px-4 py-6 bg-[#EAE6ED] rounded-bl-2xl rounded-br-2xl flex-col justify-center items-end gap-2.5 inline-flex">
        <div className="self-end justify-between items-center inline-flex">
          <div className="justify-start items-center gap-[25px] flex">
            <PrimaryButton
              style={{
                width: "160px",
                height: "48px",
                fontSize: "14px",
                background: "#BA0060",
                borderRadius: "12px",
              }}
              text={"Save"}
            />
            <PrimaryButton
              style={{
                width: "160px",
                height: "48px",
                fontSize: "14px",
                background: "#F4F4F5",
                color: "Black",
                borderRadius: "12px",
                border: "2px solid #D4D4D8",
              }}
              text={"Cancel"}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
